<template>
    <BasePanel
        :headline="$t('lang_ACCOUNTS_MAPPINGS_CAPTION_TEMPLATE_PANEL')"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="100"
            >
                <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

export default {
    name: 'MappingsTemplateReadOnlyPanel',
    components: {
        BasePanel
    },
    props: {
        mappingsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'mappings-list-row-' + this.mappingsAlvId + '-read-only-panel-template'
        }
    },
    computed: {
        headers() {
            let numOfHeaders = this.$store.getters.getMappingsDetails.fileInfo.numberOfColumns
            let headerCaptions = this.$store.getters.getDropdownOfHeaders
            let headerArray = []
            for (var i=0; i<numOfHeaders; i++) {
                let lowercaseCaption = headerCaptions[i] ? headerCaptions[i].toString() : ""
                headerArray[i] = {
                    value: i.toString(),
                    text: headerCaptions[i],
                    alvqa: this.alvqa + '-' + lowercaseCaption.toLowerCase(),
                    width: 200,
                };
            }
            return headerArray
        },
        listItems() { 
            let rowArray = []
            let numOfRows = this.$store.getters.getMappingsDetails.fileInfo.numberOfRows
            // limiting to 10 preview rows for better visibility with headers
            if (numOfRows > 10) numOfRows = 10
            let rowData = this.$store.getters.getMappingsDetails.fileInfo.data 
            for (var i=0; i<numOfRows-1; i++) {
                rowArray.push(Object.assign({}, rowData[i+1]))
            }
            return rowArray
            // return [{'col_0':'row1 Col1', 'col_1':'row 1 Col2'}, {'col_0':'row2 Col1', 'col_1':'row2 Col2'}]
        },
        listItemsLength() { return this.$store.getters.getMappingsColumnMappings.length }
    },
    created() {
        let headerRow = this.$store.getters.getMappingsDetailsHeaderRow
        if (headerRow) {
            this.$store.commit('setDropdownOfHeaders', this.$store.getters.getMappingsDetails.fileInfo.headerRow)
        }
    }
}
</script>